export default __webpack_public_path__ + "static/media/forgotpassword.aba76bb0.png";